<template>
  <div style="border: 1px solid #ccc">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      :style="`height: ${400}px; overflow-y: hidden`"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>
<script>
import Vue from "vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

export default Vue.extend({
  components: { Editor, Toolbar },
  props: {
    // 是否禁用
    disable: {
      type: Boolean,
      default: () => false,
    },
    height: {
      type: String,
      default: "400",
    },
    width: {
      type: String,
      default: "100%",
    },
    id: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
  },
  data() {
    return {
      editor: null,
      toolbarConfig: {
        toolbarKeys: [
          // 重新配置工具栏，显示哪些菜单，以及菜单的排序、分组。
          // 不配置，默认全显示
        
          "uploadImage", // 插入图片
          "insertTable", // 插入表格
          "undo", // 撤销
          "redo", // 重做
          'fullScreen', // 全屏
        ],
      },
      editorConfig: { placeholder: '', MENU_CONF: {} },
      mode: "default", // or 'simple'
    };
  },
  //vue组件生命周期函数--挂载组件完毕--------------------
  created() {
    this.editorConfig.placeholder=this.placeholder
    //上传图片
    this.uploadImg();
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    uploadImg() {
      let that = this;
      this.editorConfig.MENU_CONF["uploadImage"] = {
        // 配置上传图片的参数,这里的this指的是组件实例
        // 自定义上传
        async customUpload(file, insertFn) {
          // JS 语法
          // file 即选中的文件 <input type='file'/>
          //表单上传文件时 multipart/form-data
          // let formData = new FormData()
          // console.log(formData)
          // formData.append('file', file) //file 后台接受变量字段 file
          // console.log(file)
          //网络请求---------------------------
          let url = await that.upLoadImages64(await that.getBase64(file));
          // let { url, alt, href } = res
          // 自己实现上传，并得到图片 url alt href
          // 最后插入图片
          insertFn(url);
        },
      };
    },
    async upLoadImages64(src) {
      const { data } = await this.$http.post(`/student/upload/base64Image`, {
        base64Image: src,
      });
      return data.url;
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
  },
  watch: {
    disable: {
      handler: function (bool) {
        const editor = this.editor;
        if (editor == null) return;
        bool ? editor.disable() : editor.enable();
      },
      deep: true,
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
});
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
